import { useLocation, useParams } from 'react-router';

import { CardCarousel } from 'components/carousel';
import { Imagem } from 'components/images';
import { useBannerData } from 'hooks/useBannerData';

export function CardBanner() {
    const { data: bannerData = [] } = useBannerData();
    const { pathname } = useLocation();
    const { id } = useParams();

    if (pathname.includes('/form') || id !== undefined || !bannerData.length) return null;

    return (
        <CardCarousel
            list={bannerData}
            renderCard={({ dsLinkArquivo, dsLinkBanner }) => (
                <Imagem
                    src={dsLinkArquivo}
                    style={{
                        aspectRatio: 2560 / 466,
                        objectFit: 'cover',
                        height: 'auto',
                        width: '100%',
                        cursor: dsLinkBanner ? 'pointer' : 'default',
                    }}
                    onClick={() => dsLinkBanner && window.open(dsLinkBanner, '_blank')}
                />
            )}
        />
    );
}
